:root {
  color-scheme: light dark;
  --bg: #0f1115;
  --panel: #1a1d24;
  --border: #2a2f3a;
  --text: #e8e6e3;
  --muted: #9aa3b2;
  --accent: #c9a227;
  --accent-2: #7c5cff;
  --ming: #ff6b6b;
  --shen: #4ecdc4;
  --sihua-lu: #f0c14b;
  --sihua-quan: #ff8c42;
  --sihua-ke: #6bcb77;
  --sihua-ji: #ef476f;
  font-family: "Noto Sans SC", "PingFang SC", "Microsoft YaHei", system-ui, sans-serif;
  line-height: 1.5;
  font-weight: 400;
  color: var(--text);
  background: var(--bg);
}

* { box-sizing: border-box; }
body { margin: 0; min-height: 100vh; background: radial-gradient(1200px 600px at 10% -10%, #1e1630 0%, var(--bg) 55%); }
button, input, select { font: inherit; }
button { cursor: pointer; }
a { color: var(--accent); }

.app { max-width: 1100px; margin: 0 auto; padding: 24px 16px 80px; }
.hero h1 { margin: 0 0 8px; font-size: 1.75rem; letter-spacing: 0.04em; }
.hero p { margin: 0 0 20px; color: var(--muted); font-size: 0.95rem; }

.form {
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  background: var(--panel);
  border: 1px solid var(--border);
  border-radius: 14px;
  padding: 16px;
}
.form label { display: flex; flex-direction: column; gap: 6px; font-size: 0.85rem; color: var(--muted); }
.form input, .form select {
  background: #12141a; color: var(--text); border: 1px solid var(--border);
  border-radius: 8px; padding: 8px 10px;
}
.form .actions { grid-column: 1 / -1; display: flex; gap: 10px; flex-wrap: wrap; align-items: center; }
.btn {
  background: linear-gradient(135deg, var(--accent), #a67c00);
  color: #111; border: none; border-radius: 10px; padding: 10px 18px; font-weight: 700;
}
.btn.secondary { background: transparent; color: var(--text); border: 1px solid var(--border); font-weight: 500; }
.btn:disabled { opacity: 0.5; cursor: not-allowed; }

.meta {
  margin-top: 16px; display: flex; flex-wrap: wrap; gap: 8px 14px;
  color: var(--muted); font-size: 0.9rem;
}
.chip {
  background: #222632; border: 1px solid var(--border); border-radius: 999px;
  padding: 4px 10px; color: var(--text);
}

.board-wrap { margin-top: 18px; display: grid; gap: 16px; grid-template-columns: minmax(0, 1fr) minmax(260px, 320px); }
@media (max-width: 860px) { .board-wrap { grid-template-columns: 1fr; } }

.chart-grid {
  display: grid; grid-template-columns: repeat(4, 1fr); grid-template-rows: repeat(4, minmax(88px, auto));
  gap: 6px; background: var(--panel); border: 1px solid var(--border); border-radius: 14px; padding: 8px;
}
.palace {
  border: 1px solid var(--border); border-radius: 10px; padding: 6px 8px; background: #12151c;
  min-height: 88px; position: relative; overflow: hidden;
}
.palace.ming { outline: 2px solid var(--ming); }
.palace.shen { box-shadow: inset 0 0 0 1px var(--shen); }
.palace .head { display: flex; justify-content: space-between; font-size: 0.75rem; color: var(--muted); margin-bottom: 4px; }
.palace .name { color: var(--text); font-weight: 600; }
.palace .stars { display: flex; flex-wrap: wrap; gap: 4px; }
.star {
  font-size: 0.72rem; padding: 1px 5px; border-radius: 4px; background: #2a3140;
}
.star.major { background: #3a2f1a; color: #ffd27a; font-weight: 600; }
.star .sihua { margin-left: 2px; font-weight: 700; }
.star .sihua.禄 { color: var(--sihua-lu); }
.star .sihua.权 { color: var(--sihua-quan); }
.star .sihua.科 { color: var(--sihua-ke); }
.star .sihua.忌 { color: var(--sihua-ji); }
.center-cell {
  grid-column: 2 / 4; grid-row: 2 / 4;
  border: 1px dashed var(--border); border-radius: 12px; padding: 12px;
  display: flex; flex-direction: column; justify-content: center; gap: 6px;
  background: linear-gradient(160deg, #1b1630, #12151c);
}
.center-cell h2 { margin: 0; font-size: 1.1rem; }
.center-cell .sub { color: var(--muted); font-size: 0.85rem; }

.side {
  background: var(--panel); border: 1px solid var(--border); border-radius: 14px; padding: 14px;
  display: flex; flex-direction: column; gap: 10px; max-height: 640px; overflow: auto;
}
.side h3 { margin: 0; font-size: 1rem; }
.side .dim-tabs { display: flex; flex-wrap: wrap; gap: 6px; }
.side .dim-tabs button {
  border: 1px solid var(--border); background: #12151c; color: var(--muted);
  border-radius: 999px; padding: 4px 10px; font-size: 0.78rem;
}
.side .dim-tabs button.active { color: #111; background: var(--accent); border-color: transparent; font-weight: 600; }
.interp-body { white-space: pre-wrap; font-size: 0.85rem; color: #d5d2cc; line-height: 1.65; }
.ai-box textarea {
  width: 100%; min-height: 72px; resize: vertical; background: #12151c; color: var(--text);
  border: 1px solid var(--border); border-radius: 8px; padding: 8px;
}
.ai-out { font-size: 0.85rem; color: #d5d2cc; white-space: pre-wrap; }
.err { color: #ff8a8a; font-size: 0.85rem; }
.ok { color: #8dffb0; font-size: 0.85rem; }

.footer {
  margin-top: 36px; padding-top: 16px; border-top: 1px solid var(--border);
  color: var(--muted); font-size: 0.78rem; line-height: 1.7;
}
.footer strong { color: var(--text); font-weight: 600; }
